<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label=" 是否预设一周logo ，0否1是" prop="isRegularTime" >
        <a-input v-model="form.isRegularTime" placeholder="请输入 是否预设一周logo ，0否1是" />
      </a-form-model-item>
      <a-form-model-item label="logo图片地址" prop="imgUrl" >
        <a-input v-model="form.imgUrl" placeholder="请输入logo图片地址" />
      </a-form-model-item>
      <a-form-model-item label="文字描述" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="周一logo" prop="mondayImg" >
        <a-input v-model="form.mondayImg" placeholder="请输入周一logo" />
      </a-form-model-item>
      <a-form-model-item label="周一文字" prop="mondayContent" >
        <editor v-model="form.mondayContent" />
      </a-form-model-item>
      <a-form-model-item label="周二logo" prop="tuesdayImg" >
        <a-input v-model="form.tuesdayImg" placeholder="请输入周二logo" />
      </a-form-model-item>
      <a-form-model-item label="周二文字" prop="tuesdayContent" >
        <editor v-model="form.tuesdayContent" />
      </a-form-model-item>
      <a-form-model-item label="周三logo" prop="wednesayImg" >
        <a-input v-model="form.wednesayImg" placeholder="请输入周三logo" />
      </a-form-model-item>
      <a-form-model-item label="周三文字" prop="wednesdayContent" >
        <editor v-model="form.wednesdayContent" />
      </a-form-model-item>
      <a-form-model-item label="周四logo" prop="thursdayImg" >
        <a-input v-model="form.thursdayImg" placeholder="请输入周四logo" />
      </a-form-model-item>
      <a-form-model-item label="周四文字" prop="thursdayContent" >
        <editor v-model="form.thursdayContent" />
      </a-form-model-item>
      <a-form-model-item label="周五logo" prop="fridayImg" >
        <a-input v-model="form.fridayImg" placeholder="请输入周五logo" />
      </a-form-model-item>
      <a-form-model-item label="周五文字" prop="fridayContent" >
        <editor v-model="form.fridayContent" />
      </a-form-model-item>
      <a-form-model-item label="周六logo" prop="saturdayImg" >
        <a-input v-model="form.saturdayImg" placeholder="请输入周六logo" />
      </a-form-model-item>
      <a-form-model-item label="周六文字" prop="saturdayContent" >
        <editor v-model="form.saturdayContent" />
      </a-form-model-item>
      <a-form-model-item label="周日logo" prop="sundayImg" >
        <a-input v-model="form.sundayImg" placeholder="请输入周日logo" />
      </a-form-model-item>
      <a-form-model-item label="周日文字" prop="sundayContent" >
        <editor v-model="form.sundayContent" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLogo, addLogo, updateLogo } from '@/api/logo/logo'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        isRegularTime: null,

        imgUrl: null,

        content: null,

        mondayImg: null,

        mondayContent: null,

        tuesdayImg: null,

        tuesdayContent: null,

        wednesayImg: null,

        wednesdayContent: null,

        thursdayImg: null,

        thursdayContent: null,

        fridayImg: null,

        fridayContent: null,

        saturdayImg: null,

        saturdayContent: null,

        sundayImg: null,

        sundayContent: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        isRegularTime: null,
        imgUrl: null,
        content: null,
        mondayImg: null,
        mondayContent: null,
        tuesdayImg: null,
        tuesdayContent: null,
        wednesayImg: null,
        wednesdayContent: null,
        thursdayImg: null,
        thursdayContent: null,
        fridayImg: null,
        fridayContent: null,
        saturdayImg: null,
        saturdayContent: null,
        sundayImg: null,
        sundayContent: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLogo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateLogo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addLogo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
